import React from 'react';
import PriceForm from '../../../Components/layouts/Price/PriceForm';
function Price() {
	const showBtn = true;
	return (
		<div className='price'>
			<div className='flex flex-col justify-center items-center container-primary rel price__content'>
				<h2 className=' text-[3.2rem] text-primary-dark leading-[6.4rem] mt-[6.7rem] font-bold mb-16 text-center'>
					با چند کلیک هزینه‌ی موردنیاز برای برگزاری بوت‌کمپ خود را تخمین
					بزنید!
				</h2>
				<p className=' text-3xl text-center leading-[3rem] mb-40 '>
					با استفاده از سیستم هوشمند محاسبه‌ی هزینه‌ی مورد نیاز برگزاری
					بوت‌کمپ‌های بوت‌وب، دیگر از بابت حساب و کتاب هزینه‌های مورد نیاز
					خود نگرانی نداشته باشید.
				</p>
				<div className=' mt-[1.8rem] w-full mb-[10.4rem]'>
					<PriceForm showBtn={showBtn} />
				</div>
			</div>
		</div>
	);
}

export default Price;
